import { render, staticRenderFns } from "./KPILayout.vue?vue&type=template&id=ec8fbac6&"
import script from "./KPILayout.vue?vue&type=script&lang=js&"
export * from "./KPILayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports